import Echo from "laravel-echo";
import Pusher from "pusher-js";
import axios from "axios";
import { getAuthToken } from "../helper/common.helper";

// laravel-echo connector Pusher for broadcaster "reverb"
window.Pusher = Pusher;

const token = getAuthToken();

export const apiClientPlatform = axios.create({
	baseURL: `${process.env.REACT_APP_API_HOST_PLATFORM}/`,
});

export const apiClient = axios.create({
	baseURL: `${process.env.REACT_APP_API_HOST}/`,
});

export const apiClientTodoTd = axios.create({
	baseURL: `${process.env.REACT_APP_HOST_API_TODO}`,
});

export const SocketEcho = new Echo({
	broadcaster: "reverb",
	key: process.env.REACT_APP_SOCKET_KEY,
	//cluster: "eu",
	//forceTLS: true,
	wsHost: process.env.REACT_APP_WS_HOST,
	wsPort: 80,
	wssPort: 443,
	forceTLS: true,
	enabledTransports: ["ws", "wss"],
	authEndpoint: `${process.env.REACT_APP_API_HOST}/broadcasting/auth`,
	auth: {
		headers: {
			Accept: "application/json",
			Authorization: token ? `Bearer ${token}` : "",
		},
	},
});

/**
 * Interceptors Requests
 */
apiClient.interceptors.request.use(
	(config) => {
		if (localStorage.getItem("userData")) {
			const { token } = JSON.parse(localStorage.getItem("userData"));
			config.headers.Authorization = token ? `Bearer ${token}` : "";
		}

		return config;
	},
	(error) => {
		// Do something with request error
		return Promise.reject(error);
	}
);

/**
 * Interceptors Response
 */
apiClient.interceptors.response.use(
	(response) => response,
	async (error) => {
		if (error?.response?.status === 401) {
			errorSession();
		}
		return Promise.reject(error);
	}
);

function errorSession() {
	if (localStorage.getItem("userData")) {
		localStorage.removeItem("userData");
		localStorage.removeItem("globalFilterEvents");
		localStorage.removeItem("tenant");
		window.location = "/";
	}
}
